/**
 * Created by 58 on 2017/7/11.
 */
var config = require('./../ui/global/config');
var dispatcher = require('./../ui/global/dispatcher');
var ActionType = require('./../ui/constant/ActionType');
var infoQuaCheck = require('./infoQuaCheck');
var utils = require('./../ui/global/utils');
var _jsonHandler = utils.jsonHandler;
var _me;
var _contact;
var isNeedConvert = function (content) {
  if (!content || !content.extra) {
    return false;
  }

  var extrainfo = content.extra;
  if (typeof (content.extra) === 'string') {
    extrainfo = _jsonHandler.parse(content.extra);
  }
  if (!extrainfo.richtext_format) {
    return false;
  }

  var flag = true;
  if (content && content.extra) {
    var richtext_format = extrainfo.richtext_format;
    var richtext = richtext_format.richtext;
    var format = richtext_format.format;
    // 对于富文本格式传入不正确的，不处理
    if (!richtext || !format || richtext === '' || format.length === 0) {
      flag = false;
    }
  } else {
    // 对不符合富文本格式的内容，直接返回
    flag = false;
  }
  return flag;
};
var _format = function (richtext, foramt) {
  richtext = richtext.replace(/\{\d{1,}\}/g, function (item) {
    var num = item.toString().split('{')[1].split('}')[0];
    if (num > foramt.length - 1) {
      return item;
    }
    var url = foramt[num].url ? foramt[num].url : '';
    var color = foramt[num].color ? foramt[num].color.toString() : 'blue';
    var font_weight = foramt[num].bold && foramt[num].bold.toString() === '1' ? 'bold' : 'normal';
    var action_code = foramt[num].action_code ? foramt[num].action_code.toString() : '';
    var rich_text;
    var xz_opts = {
      action_code: null,
      me: {
        user_id: _me.user_id,
        user_source: _me.user_source
      },
      contact: {
        user_id: _contact.user_id,
        user_source: _contact.user_source
      },
      xz_source: config['xz-source']
    };
    var xxzlwl_opts, xxzlwl_rz_opts;

    // 不同跳转方式
    switch (action_code) {
      case '1002':
        // 通用不跳转
        url = 'javascript:void(0)';
        break;
      case '1003':
        xz_opts.action_type = 'appeal';
        xxzlwl_opts = infoQuaCheck(xz_opts);
        break;
      case '1004':
        xz_opts.action_type = 'complaints';
        xxzlwl_opts = infoQuaCheck(xz_opts);
        break;
      case '1005':
        xz_opts.action_type = 'faceVerify';
        xxzlwl_rz_opts = infoQuaCheck(xz_opts);
        break;
      case '1001':
      default:
        break
    }
    if (xxzlwl_opts) {
      rich_text = "<span style='cursor:pointer;color:#" + color + ";font-weight:" + font_weight + ";' onclick='window.top.XXZLWL.Config(" + JSON.stringify(xxzlwl_opts) + ")'>" + foramt[num].linktext + "</span>";
    } else if (xxzlwl_rz_opts) {
      rich_text = "<span style='cursor:pointer;color:#" + color + ";font-weight:" + font_weight + ";' onclick='window.top.XXZLWL.faceVerify(" + JSON.stringify(xxzlwl_rz_opts) + ")'>" + foramt[num].linktext + "</span>";
    } else {
      rich_text = "<a href='" + url + "' style='cursor:pointer;text-decoration:none;color:#" + color + ";font-weight:" + font_weight + "' target='_blank'>" + foramt[num].linktext + "</a>";
    }
    return rich_text;
  });
  return richtext;
};

var _formatOrg = function (richtext, foramt) {
  richtext = richtext.replace(/\{\d{1,}\}/g, function (item) {
    var num = item.toString().split('{')[1].split('}')[0];
    if (num > foramt.length - 1) {
      return item;
    }
    return foramt[num].linktext;
  });
  return richtext;
}

var richTextFormat = function (msg) {
  // 确认消息双方，便于信质使用
  _me = config['me']();
  _contact = {};
  if (_me.user_id + '' === msg.to_id + '' && _me.user_source + '' === msg.to_source + '') {
    _contact.user_id = msg.sender_id;
    _contact.user_source = msg.sender_source;
  }
  else {
    _contact.user_id = msg.to_id;
    _contact.user_source = msg.to_source;
  }


  var content = msg.content;
  if (!isNeedConvert(content)) {
    return msg;
  }


  // 对文本进行富文本转换
  var extrainfo = _jsonHandler.parse(content.extra);
  if (!extrainfo || !extrainfo.richtext_format || !extrainfo.richtext_format.richtext) {
    return msg;
  }
  var richtext_format = extrainfo.richtext_format;
  var richtext = richtext_format.richtext;
  var format = richtext_format.format;

  // 文本消息
  if (content.type.toString() === 'text') {
    content.msg = _format(richtext, format);
  } else if (content.type.toString() === 'tip') {
    content.text = _format(richtext, format);
    content.origl_text = _formatOrg(richtext, format);
  }
  msg.content = content;
  return msg;
};

module.exports = {
  richTextFormat: richTextFormat,
  isNeedConvert: isNeedConvert
};